import { createSelector } from '@ngrx/store';
import { State } from '../../../reducers';
import ChargepointState from '../reducers/chargepoint.reducer';

export const selectChargepointData = (state: State) => state.chargepoint;

export const selectChargepointSummary = createSelector(selectChargepointData, (chargepointState: ChargepointState) =>
  (chargepointState.summary || []).filter(s => s.totalSessions > 0).sort((a, b) => b.totalSessions - a.totalSessions),
);

export const selectChargepointLoading = createSelector(selectChargepointData, (chargepointState: ChargepointState) => chargepointState.loading);

export const selectChargepointError = createSelector(selectChargepointData, (chargepointState: ChargepointState) => chargepointState.error);

export const selectChargepointTotalSessions = createSelector(selectChargepointSummary, summary => summary.reduce((sum, s) => sum + s.totalSessions, 0));

export const selectChargepointTotalEnergy = createSelector(selectChargepointSummary, summary => summary.reduce((sum, s) => sum + s.totalEnergyKWh, 0));

export const selectChargepointAverageSessionTime = createSelector(selectChargepointSummary, summary => {
  const sessionsWithDuration = summary.filter(s => s.totalSessions > 0);
  if (!sessionsWithDuration.length) return 0;
  const totalAvg = sessionsWithDuration.reduce((sum, s) => sum + s.averageSessionDurationMin, 0);
  return totalAvg / sessionsWithDuration.length;
});

export const selectChargepointByFacilityName = (facilityName: string) =>
  createSelector(selectChargepointSummary, summary => summary.find(item => item.facilityName === facilityName));
